import { useState } from 'react';

export function LibroReclamaciones() {
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    // PLACEHOLDER: enviar a Cosmos `libro_reclamaciones` + email a soporte
    // (RC-LEGAL-020 Sprint 15)
    setSubmitted(true);
  }

  if (submitted) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 lg:px-8 text-center">
        <h1 className="text-3xl font-bold">Tu reclamo fue registrado</h1>
        <p className="mt-4 text-text-secondary">
          Hemos enviado una copia a tu correo. Recibiras una respuesta formal dentro de los
          siguientes <strong>30 dias calendario</strong>, conforme a la normativa peruana.
        </p>
        <p className="mt-2 text-xs text-text-tertiary">
          Numero de hoja: HR-{Date.now()} (placeholder, generar formalmente en RC-LEGAL-020).
        </p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl px-4 py-16 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold tracking-tight">Libro de Reclamaciones virtual</h1>
      <p className="mt-2 text-sm text-text-tertiary">
        Conforme al Codigo de Proteccion y Defensa del Consumidor del Peru (Ley 29571).
      </p>

      <div className="mt-6 rounded-lg border border-border-subtle bg-bg-secondary p-4 text-sm">
        <p>
          <strong>Proveedor:</strong> Paul Marquina / ExamsReactor
        </p>
        <p>
          <strong>Direccion:</strong> Lima, Peru
        </p>
        <p>
          <strong>Email:</strong> paul.marquina@outlook.com
        </p>
      </div>

      <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
        <fieldset className="space-y-4 rounded-lg border border-border-subtle p-4">
          <legend className="px-2 text-sm font-semibold">Datos del consumidor</legend>
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <label className="block text-sm font-medium">Nombre completo</label>
              <input required className="input mt-1" />
            </div>
            <div>
              <label className="block text-sm font-medium">DNI / Documento</label>
              <input required className="input mt-1" />
            </div>
            <div>
              <label className="block text-sm font-medium">Telefono</label>
              <input className="input mt-1" />
            </div>
            <div>
              <label className="block text-sm font-medium">Email</label>
              <input required type="email" className="input mt-1" />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium">Direccion</label>
              <input required className="input mt-1" />
            </div>
          </div>
        </fieldset>

        <fieldset className="space-y-4 rounded-lg border border-border-subtle p-4">
          <legend className="px-2 text-sm font-semibold">Identificacion del bien o servicio</legend>
          <div>
            <label className="block text-sm font-medium">Tipo</label>
            <select required className="input mt-1">
              <option value="servicio">Servicio (suscripcion ExamsReactor)</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium">Monto reclamado (S/)</label>
            <input type="number" step="0.01" className="input mt-1" />
          </div>
        </fieldset>

        <fieldset className="space-y-4 rounded-lg border border-border-subtle p-4">
          <legend className="px-2 text-sm font-semibold">Detalle del reclamo o queja</legend>
          <div>
            <label className="block text-sm font-medium">Tipo</label>
            <div className="mt-2 flex gap-4 text-sm">
              <label className="flex items-center gap-2">
                <input type="radio" name="tipo" value="reclamo" defaultChecked />
                <span>Reclamo</span>
              </label>
              <label className="flex items-center gap-2">
                <input type="radio" name="tipo" value="queja" />
                <span>Queja</span>
              </label>
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium">Descripcion (max 2000 caracteres)</label>
            <textarea required rows={6} maxLength={2000} className="input mt-1" />
          </div>
          <div>
            <label className="block text-sm font-medium">Pedido del consumidor</label>
            <textarea required rows={3} maxLength={1000} className="input mt-1" />
          </div>
        </fieldset>

        <button type="submit" className="btn-primary">
          Enviar reclamo
        </button>
        <p className="text-xs text-text-tertiary">
          Recibiras una respuesta formal dentro de los <strong>30 dias calendario</strong> conforme
          a la normativa peruana.
        </p>
      </form>
    </div>
  );
}
